export const theme = {
  colors: {
    textMain: '#2E2E2E',
    textSub: '#5C5C5C',
    textXSub: '#727272',
    bgColor: '#fff',
    yellow: '#f4ac65',
    lightYellow: '#fdd591',
    offWhite: '#fbfbfb',
    offWhite2: '#edeff0',
    light: '#ebedee',
  },
  fontWeights: {
    normal: 400,
    bold: 700,
    xBold: 800,
  },
  fontFace: `Poppins, sans-serif`,
  borderRadius: '45px',
  borderRadiusX: '6px',
}
